import { render, staticRenderFns } from "./addgame.vue?vue&type=template&id=7626d80b&"
import script from "./addgame.vue?vue&type=script&lang=js&"
export * from "./addgame.vue?vue&type=script&lang=js&"
import style0 from "./addgame.vue?vue&type=style&index=0&id=7626d80b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports